import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTattooFromPhotoConverterConfig } from '@/data/landingConfig/landingTattooFromPhotoConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TattooFromPhotoConverter } from './schemaObject';

interface Props {}
const TattooFromPhotoConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TattooFromPhotoConverter} />
			<LandingTemplate
				data={landingTattooFromPhotoConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTattooGenerator()}
			/>
		</>
	);
};

export default TattooFromPhotoConverter;
